module.exports = __webpack_public_path__ + "static/media/stats-48states.13f67b1f.png";